import { Button, Typography, Space } from 'antd';
import { LoginOutlined, FileTextOutlined } from '@ant-design/icons';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';

const { Title, Text } = Typography;

const LoginPage = () => {
  const { isAuthenticated, initialized, login } = useAuth();

  // Already logged in → go to dashboard
  if (initialized && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: 24,
      }}
    >
      <div
        className="ui-surface ui-animate-in"
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: 20,
          padding: '44px 40px 36px',
          background: 'var(--color-bg-base)',
        }}
      >
        {/* Logo + App Name */}
        <Space direction="vertical" align="center" style={{ width: '100%', marginBottom: 32 }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 18,
              background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 10px 30px -8px rgba(79, 70, 229, 0.5)',
            }}
          >
            <FileTextOutlined style={{ fontSize: 32, color: 'var(--color-text-inverse)' }} />
          </div>
          <Title
            level={2}
            className="ui-gradient-text"
            style={{ margin: '4px 0 0', letterSpacing: '-0.03em', fontWeight: 800 }}
          >
            RFO Portal
          </Title>
          <Text type="secondary" style={{ textAlign: 'center', display: 'block' }}>
            Request for Opportunity management platform
          </Text>
        </Space>

        {/* Sign In */}
        <Button
          type="primary"
          icon={<LoginOutlined />}
          block
          size="large"
          onClick={login}
          style={{
            background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
            border: 'none',
            height: 48,
            fontSize: 15,
            fontWeight: 600,
            borderRadius: 10,
            boxShadow: '0 8px 24px -10px rgba(79, 70, 229, 0.6)',
          }}
        >
          Sign In
        </Button>
      </div>
    </div>
  );
};

export default LoginPage;
